import {
  Box,
  Card,
  CircularProgress,
  Grid,
  Typography,
  Button,
} from "@mui/material";
import { ref, onValue, remove } from "firebase/database";
import { FC, useState, useEffect } from "react";
import { database } from "../../../firebase/firebase-config";
import { useNavigate } from "react-router-dom";

export const GSMList: FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const gsmRef = ref(database, "GSM");

    const unsubscribe = onValue(
      gsmRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const gsmData = snapshot.val();
          const gsmArray = Object.keys(gsmData).map((key) => ({
            id: key,
            ...gsmData[key],
          }));
          setData(gsmArray);
        } else {
          setError("No data available");
        }
        setLoading(false);
      },
      (error) => {
        setError("Failed to fetch data");
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  const handleDelete = async (id: string) => {
    try {
      const docRef = ref(database, `GSM/${id}`);
      await remove(docRef);
      setData((prevData) => prevData.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Failed to delete GSM:", error);
      setError("Failed to delete GSM");
    }
  };

  if (loading) {
    return (
      <Box
        height="100vh"
        display="flex"
        flexDirection="column"
        justifyContent={"center"}
        alignContent={"center"}
        alignItems={"center"}
        alignSelf={"center"}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography variant="h6" color="error">
        {error}
      </Typography>
    );
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ padding: 2 }}
    >
      <Grid container spacing={2} justifyContent="center">
        {data.map((gsm) => (
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={4}
            key={gsm.id}
            display="flex"
            justifyContent="center"
          >
            <Card
              variant="outlined"
              sx={{
                margin: 2,
                width: "100%",
                maxWidth: 400,
                padding: 2,
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <Box>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ fontWeight: "bold" }}
                >
                  {gsm.createdByUser
                    .charAt(0)
                    .toUpperCase()
                    .concat(gsm.createdByUser.substring(1).split("@")[0])}
                  's input{" "}
                </Typography>
                <Typography variant="h6" component="div">
                  Brand: {gsm.brand}
                </Typography>
                <Typography variant="h6" component="div">
                  Model: {gsm.model}
                </Typography>
                <Typography variant="h6" component="div">
                  Date_IN: {gsm.Date_IN}
                </Typography>
                <Typography variant="h6" component="div">
                  Date_OUT: {gsm.Date_OUT}
                </Typography>
                <Typography variant="h6" component="div">
                  IMEI_number: {gsm.IMEI_number}
                </Typography>
                <Typography variant="h6" component="div">
                  SIN_Number: {gsm.SIN_Number}
                </Typography>
                <Typography variant="h6" component="div">
                  PV_number: {gsm.PV_number}
                </Typography>
                <Typography variant="h6" component="div">
                  SIM_code: {gsm.SIM_code}
                </Typography>
                <Typography variant="h6" component="div">
                  Unlock_code: {gsm.Unlock_code}
                </Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" mt={2}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => navigate(`/gsm/${gsm.id}`)}
                >
                  Edit
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleDelete(gsm.id)}
                >
                  Delete
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
